// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__iRP2z","item":"PaymentsMobile_item__wrH8j","label":"PaymentsMobile_label__32d42","amount":"PaymentsMobile_amount__1Wa_B"};